const initDiaporamas = () => {
	var diaporamas = [].slice.call(document.querySelectorAll(".js-block-diaporama"));

	if (diaporamas.length) {
		diaporamas.forEach(function (diaporama) {
			let config = {
				speed: 750,
			};

			if (diaporama.getAttribute("data-autoplay")) {
				config.autoplay = {
					delay: 6500,
					disableOnInteraction: false,
				};
			}

			if (diaporama.getAttribute("data-navigation")) {
				config.navigation = {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				};
			}

			if (diaporama.getAttribute("data-pagination")) {
				config.pagination = {
					el: ".swiper-pagination",
					clickable: true,
				};
			}

			let swiperInst = new Swiper(
				"#" + diaporama.getAttribute("id"),
				config
			);
		});
	}
};

document.addEventListener("DOMContentLoaded", () => {
	initDiaporamas();
});

window.addEventListener("force_init_from_backoffice", () => {
	initDiaporamas();
});
